"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENVIRONMENT_DOMAINS = exports.REGION = exports.LOCAL_ENVS = void 0;
exports.LOCAL_ENVS = [/^localhost/, /^core\.dev/, /raisin-dev/, /^bk-/, /bk\./, /staging-/, /amplifyapp/];
exports.REGION = {
  GBR: 'GBR',
  DEU: 'DEU'
};
exports.ENVIRONMENT_DOMAINS = {
  development: 'dev-',
  staging: 'staging-',
  onboarding: 'onboarding-',
  production: ''
};